export default __webpack_public_path__ + "static/media/5.de9cd20f.jpg";